export const SERVICE_TYPE = {
    EVC_MEMBER: 'EVC_MEMBER',
    EVC_PUBLIC: 'EVC_PUBLIC',
    EVC_OWNER: 'EVC_OWNER'
};
